import { Flex } from '@indoqa/style-system';
import * as React from 'react';
import { FelaComponent } from 'react-fela';
import { Link } from 'react-router-dom';
import { withUIETheme } from '../uietheme/withUIETheme';
import MainHeading from './MainHeading';
const Logo = ({ uieTheme, to, children }) => {
    if (typeof children !== 'string') {
        return (React.createElement(Flex, { fullWidth: true, justifyContent: "center" },
            React.createElement(Link, { to: to }, children)));
    }
    const style = {
        listStyle: 'none',
        paddingLeft: uieTheme.spacing.space4,
        '& > a': {
            textDecoration: 'none',
        },
        tablet: {
            paddingLeft: uieTheme.spacing.space3,
        },
    };
    return (React.createElement(FelaComponent, { style: style },
        React.createElement(Link, { to: to },
            React.createElement(MainHeading, null, children))));
};
export default withUIETheme(Logo);
//# sourceMappingURL=Logo.js.map